export default "__VITE_ASSET__0pdDOMKy__"